module.exports = __webpack_public_path__ + "assets/683f79fe582c239cf19bc9cbef01e704.mp3";